import styled from 'styled-components';
import { Link } from 'react-router-dom';

const LinkReviews = styled(Link)`
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold};
  color: ${({ theme }) => theme.colors.night_blue_1};
  margin-left: ${({ theme }) => theme.spacing(1)};
  font-weight: normal;
  display: flex;
  align-items: center;
  width: fit-content;
`;

export default LinkReviews;
